import type { FulfillmentConfiguration } from '@ofmos/shared/fulfillment-configuration';
import { OFMOS_FULFILLMENT } from '@ofmos/shared/ofmos-configuration';

/**
 * THE CONFIGURATION THIS BUILD SERVES (DESIGN.md Part 1 priority 7).
 *
 * The one file in the web that names an installation's configuration. Every model and hook of the
 * fulfillment pages takes a `FulfillmentConfiguration` as its last argument and defaults it to
 * this value, so the pages call them as before and a test passes another configuration to prove
 * the behaviour follows it. A second installation changes this line, nothing else.
 */
export const FULFILLMENT: FulfillmentConfiguration = OFMOS_FULFILLMENT;
